/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1SerieSerieidLangsIdQueryResponse,
  GetApiV1SerieSerieidLangsIdPathParams,
  GetApiV1SerieSerieidLangsId401,
  GetApiV1SerieSerieidLangsId404,
  GetApiV1SerieSerieidLangsId500,
} from "../../types/serieIdiomasController/GetApiV1SerieSerieidLangsId.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1SerieSerieidLangsId } from "../../clients/serieIdiomasController/getApiV1SerieSerieidLangsId.ts";

export const getApiV1SerieSerieidLangsIdQueryKey = (
  serieId: GetApiV1SerieSerieidLangsIdPathParams["serieId"],
  id: GetApiV1SerieSerieidLangsIdPathParams["id"],
) =>
  [
    {
      url: "/api/v1/serie/:serieId/langs/:id",
      params: { serieId: serieId, id: id },
    },
  ] as const;

export type GetApiV1SerieSerieidLangsIdQueryKey = ReturnType<
  typeof getApiV1SerieSerieidLangsIdQueryKey
>;

export function getApiV1SerieSerieidLangsIdQueryOptions(
  serieId: GetApiV1SerieSerieidLangsIdPathParams["serieId"],
  id: GetApiV1SerieSerieidLangsIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1SerieSerieidLangsIdQueryKey(serieId, id);
  return queryOptions<
    GetApiV1SerieSerieidLangsIdQueryResponse,
    ResponseErrorConfig<
      | GetApiV1SerieSerieidLangsId401
      | GetApiV1SerieSerieidLangsId404
      | GetApiV1SerieSerieidLangsId500
    >,
    GetApiV1SerieSerieidLangsIdQueryResponse,
    typeof queryKey
  >({
    enabled: !!(serieId && id),
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1SerieSerieidLangsId(serieId, id, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna uma tradução (idioma) de série pelo seu identificador. **(Requer Authorization para autenticação)**
 * @summary Obter idioma por ID (Requer Authorization para autenticação)
 * {@link /api/v1/serie/:serieId/langs/:id}
 */
export function useGetApiV1SerieSerieidLangsId<
  TData = GetApiV1SerieSerieidLangsIdQueryResponse,
  TQueryData = GetApiV1SerieSerieidLangsIdQueryResponse,
  TQueryKey extends QueryKey = GetApiV1SerieSerieidLangsIdQueryKey,
>(
  serieId: GetApiV1SerieSerieidLangsIdPathParams["serieId"],
  id: GetApiV1SerieSerieidLangsIdPathParams["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1SerieSerieidLangsIdQueryResponse,
        ResponseErrorConfig<
          | GetApiV1SerieSerieidLangsId401
          | GetApiV1SerieSerieidLangsId404
          | GetApiV1SerieSerieidLangsId500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1SerieSerieidLangsIdQueryKey(serieId, id);

  const query = useQuery(
    {
      ...getApiV1SerieSerieidLangsIdQueryOptions(serieId, id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1SerieSerieidLangsId401
      | GetApiV1SerieSerieidLangsId404
      | GetApiV1SerieSerieidLangsId500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
